// extracted by mini-css-extract-plugin
export default {"container":"MobileBgWhiteBlur_container__s8Swu"};